import React, { PureComponent } from "react";
import { Modal, Button } from "react-bootstrap";
import { Scrollbars } from "react-custom-scrollbars";

import Auth from "routes/Auth";
import Teams from "api/Teams";
import EventEmitter from "services/event-emitter";
import { Step5 } from "components/get-started/modal";

const renderTeamMembers = () => {
  return (
    <div className="step5__right">
      {Teams.players()
        .filter(player => player.role !== "VI")
        .map(this.renderTeamPlayer)}
    </div>
  );
};

class TeamProfilePage extends PureComponent {
  constructor(props) {
    super(props);

    this.state = { show: false };
    this.eventemitter = EventEmitter.getInstance();
  }

  componentDidMount() {
    this.eventemitter.on("team-profile-modal-show", this.showModal);
    this.eventemitter.on("team-profile-modal-hide", this.hideModal);
  }

  componentWillUnmount() {
    this.eventemitter.off("team-profile-modal-show", this.showModal);
    this.eventemitter.off("team-profile-modal-hide", this.hideModal);
  }

  showModal = () => {
    this.setState({ show: true });
  };

  hideModal = () => {
    this.setState(
      {
        show: false
      },
      () => {
        if (this.state.returnToGuide === true) {
          this.setState({
            returnToGuide: false
          });
        }
      }
    );
  };

  get roleKey() {
    return Auth.getRole().toLowerCase();
  }

  get role() {
    const role = this.roleKey;

    if (role === "ceo") {
      return "CEO";
    } else if (role === "pd") {
      return "Head of Product Development";
    } else if (role === "pm") {
      return "Head of Product Marketing";
    } else if (role === "op") {
      return "Head of Operations";
    } else if (role === "fi") {
      return "Head of Finance";
    } else if (role === "vi") {
      return "Viewer";
    }

    return "";
  }

  render() {
    const { show } = this.state;
    const currentTeam = Teams.currentTeam();

    return (
      <Modal
        show={show}
        onHide={this.hideModal}
        dialogClassName="getStarterModal feedback-modal"
        backdrop={true}
        backdropClassName="feedback-backdrop"
      >
        <Modal.Body>
          <Scrollbars style={{ height: "calc(100% - 60px)" }}>
            <div className="steps">
              <p className={"steps__title"}>
                Your Team: {currentTeam ? currentTeam.name : ""}
              </p>
              <Step5 renderTeamMembers={renderTeamMembers} />
            </div>
          </Scrollbars>
        </Modal.Body>
        <Modal.Footer bsClass="modal-footer modal-footer-my-profile">
          <Button bsStyle="primary" onClick={this.hideModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default TeamProfilePage;



// WEBPACK FOOTER //
// ./src/components/team-profile-page/index.js